/* constituencyData.js
   Mapping of Tamil Nadu Assembly Constituency Numbers to Districts.
   Based on 2008 delimitation.
*/

export const constituencyToDistrict = {
  1: "திருவள்ளூர்",
  2: "திருவள்ளூர்",
  3: "திருவள்ளூர்",
  4: "திருவள்ளூர்",
  5: "திருவள்ளூர்",
  6: "திருவள்ளூர்",
  7: "திருவள்ளூர்",
  8: "திருவள்ளூர்",
  9: "திருவள்ளூர்",
  10: "திருவள்ளூர்",
  11: "சென்னை",
  12: "சென்னை",
  13: "சென்னை",
  14: "சென்னை",
  15: "சென்னை",
  16: "சென்னை",
  17: "சென்னை",
  18: "சென்னை",
  19: "சென்னை",
  20: "சென்னை",
  21: "சென்னை",
  22: "சென்னை",
  23: "சென்னை",
  24: "சென்னை",
  25: "சென்னை",
  26: "சென்னை",
  27: "செங்கல்பட்டு",
  28: "காஞ்சிபுரம்",
  29: "காஞ்சிபுரம்",
  30: "செங்கல்பட்டு",
  31: "செங்கல்பட்டு",
  32: "செங்கல்பட்டு",
  33: "செங்கல்பட்டு",
  34: "செங்கல்பட்டு",
  35: "செங்கல்பட்டு",
  36: "காஞ்சிபுரம்",
  37: "காஞ்சிபுரம்",
  38: "இராணிப்பேட்டை",
  39: "இராணிப்பேட்டை",
  40: "வேலூர்",
  41: "இராணிப்பேட்டை",
  42: "இராணிப்பேட்டை",
  43: "வேலூர்",
  44: "வேலூர்",
  45: "வேலூர்",
  46: "வேலூர்",
  47: "திருப்பத்தூர்",
  48: "திருப்பத்தூர்",
  49: "திருப்பத்தூர்",
  50: "திருப்பத்தூர்",
  51: "கிருஷ்ணகிரி",
  52: "கிருஷ்ணகிரி",
  53: "கிருஷ்ணகிரி",
  54: "கிருஷ்ணகிரி",
  55: "கிருஷ்ணகிரி",
  56: "கிருஷ்ணகிரி",
  57: "தருமபுரி",
  58: "தருமபுரி",
  59: "தருமபுரி",
  60: "தருமபுரி",
  61: "தருமபுரி",
  62: "திருவண்ணாமலை",
  63: "திருவண்ணாமலை",
  64: "திருவண்ணாமலை",
  65: "திருவண்ணாமலை",
  66: "திருவண்ணாமலை",
  67: "திருவண்ணாமலை",
  68: "திருவண்ணாமலை",
  69: "திருவண்ணாமலை",
  70: "விழுப்புரம்",
  71: "விழுப்புரம்",
  72: "விழுப்புரம்",
  73: "விழுப்புரம்",
  74: "விழுப்புரம்",
  75: "விழுப்புரம்",
  76: "விழுப்புரம்",
  77: "கள்ளக்குறிச்சி",
  78: "கள்ளக்குறிச்சி",
  79: "கள்ளக்குறிச்சி",
  80: "கள்ளக்குறிச்சி",
  81: "சேலம்",
  82: "சேலம்",
  83: "சேலம்",
  84: "சேலம்",
  85: "சேலம்",
  86: "சேலம்",
  87: "சேலம்",
  88: "சேலம்",
  89: "சேலம்",
  90: "சேலம்",
  91: "சேலம்",
  92: "நாமக்கல்",
  93: "நாமக்கல்",
  94: "நாமக்கல்",
  95: "நாமக்கல்",
  96: "நாமக்கல்",
  97: "நாமக்கல்",
  98: "ஈரோடு",
  99: "ஈரோடு",
  100: "ஈரோடு",
  101: "திருப்பூர்", // Dharapuram is in Tiruppur dist
  102: "திருப்பூர்", // Kangayam
  103: "ஈரோடு", // Perundurai
  104: "ஈரோடு", // Bhavani
  105: "ஈரோடு", // Anthiyur
  106: "ஈரோடு", // Gobichettipalayam
  107: "ஈரோடு", // Bhavanisagar
  108: "நீலகிரி", // Udhagamandalam
  109: "நீலகிரி", // Gudalur
  110: "நீலகிரி", // Coonoor
  111: "கோயம்புத்தூர்", // Mettupalayam
  112: "திருப்பூர்", // Avinashi
  113: "திருப்பூர்", // Tiruppur North
  114: "திருப்பூர்", // Tiruppur South
  115: "திருப்பூர்", // Palladam
  116: "கோயம்புத்தூர்", // Sulur
  117: "கோயம்புத்தூர்", // Kavundampalayam
  118: "கோயம்புத்தூர்", // Coimbatore North
  119: "கோயம்புத்தூர்", // Thondamuthur
  120: "கோயம்புத்தூர்", // Coimbatore South
  121: "கோயம்புத்தூர்", // Singanallur
  122: "கோயம்புத்தூர்", // Kinathukadavu
  123: "கோயம்புத்தூர்", // Pollachi
  124: "கோயம்புத்தூர்", // Valparai
  125: "திருப்பூர்", // Udumalpet
  126: "திருப்பூர்", // Madathukulam
  127: "திண்டுக்கல்", // Palani
  128: "திண்டுக்கல்", // Oddanchatram
  129: "திண்டுக்கல்", // Athoor
  130: "திண்டுக்கல்", // Nilakkottai
  131: "திண்டுக்கல்", // Natham
  132: "திண்டுக்கல்", // Dindigul
  133: "திண்டுக்கல்", // Vedasandur
  134: "கரூர்", // Aravakurichi
  135: "கரூர்", // Karur
  136: "கரூர்", // Krishnarayapuram
  137: "கரூர்", // Kulithalai
  138: "திருச்சிராப்பள்ளி", // Manapparai
  139: "திருச்சிராப்பள்ளி", // Srirangam
  140: "திருச்சிராப்பள்ளி", // Tiruchirappalli West
  141: "திருச்சிராப்பள்ளி", // Tiruchirappalli East
  142: "திருச்சிராப்பள்ளி", // Thiruverumbur
  143: "திருச்சிராப்பள்ளி", // Lalgudi
  144: "திருச்சிராப்பள்ளி", // Manachanallur
  145: "திருச்சிராப்பள்ளி", // Musiri
  146: "திருச்சிராப்பள்ளி", // Thuraiyur
  147: "பெரம்பலூர்", // Perambalur
  148: "பெரம்பலூர்", // Kunnam
  149: "அரியலூர்", // Ariyalur
  150: "அரியலூர்", // Jayankondam
  151: "கடலூர்", // Tittakudi
  152: "கடலூர்", // Vridhachalam
  153: "கடலூர்", // Neyveli
  154: "கடலூர்", // Panruti
  155: "கடலூர்", // Cuddalore
  156: "கடலூர்", // Kurinjipadi
  157: "கடலூர்", // Bhuvanagiri
  158: "கடலூர்", // Chidambaram
  159: "கடலூர்", // Kattumannarkoil
  160: "மயிலாடுதுறை", // Sirkali
  161: "மயிலாடுதுறை", // Mayiladuthurai
  162: "மயிலாடுதுறை", // Poompuhar
  163: "நாகப்பட்டினம்", // Nagapattinam
  164: "நாகப்பட்டினம்", // Kilvelur
  165: "நாகப்பட்டினம்", // Vedaranyam
  166: "திருவாரூர்", // Thiruthuraipoondi
  167: "திருவாரூர்", // Mannargudi
  168: "திருவாரூர்", // Tiruvarur
  169: "திருவாரூர்", // Nannilam
  170: "தஞ்சாவூர்", // Thiruvidaimarudur
  171: "தஞ்சாவூர்", // Kumbakonam
  172: "தஞ்சாவூர்", // Papanasam
  173: "தஞ்சாவூர்", // Thiruvaiyaru
  174: "தஞ்சாவூர்", // Thanjavur
  175: "தஞ்சாவூர்", // Orathanadu
  176: "தஞ்சாவூர்", // Pattukkottai
  177: "தஞ்சாவூர்", // Peravurani
  178: "புதுக்கோட்டை", // Gandarvakottai
  179: "புதுக்கோட்டை", // Viralimalai
  180: "புதுக்கோட்டை", // Pudukkottai
  181: "புதுக்கோட்டை", // Thirumayam
  182: "புதுக்கோட்டை", // Alangudi
  183: "புதுக்கோட்டை", // Aranthangi
  184: "சிவகங்கை", // Karaikudi
  185: "சிவகங்கை", // Tiruppattur
  186: "சிவகங்கை", // Sivaganga
  187: "சிவகங்கை", // Manamadurai
  188: "மதுரை", // Melur
  189: "மதுரை", // Madurai East
  190: "மதுரை", // Sholavandan
  191: "மதுரை", // Madurai North
  192: "மதுரை", // Madurai South
  193: "மதுரை", // Madurai Central
  194: "மதுரை", // Madurai West
  195: "மதுரை", // Thiruparankundram
  196: "மதுரை", // Thirumangalam
  197: "மதுரை", // Usilampatti
  198: "தேனி", // Andipatti
  199: "தேனி", // Periyakulam
  200: "தேனி", // Bodinayakanur
  201: "தேனி", // Cumbum
  202: "விருதுநகர்", // Rajapalayam
  203: "விருதுநகர்", // Srivilliputhur
  204: "விருதுநகர்", // Sattur
  205: "விருதுநகர்", // Sivakasi
  206: "விருதுநகர்", // Virudhunagar
  207: "விருதுநகர்", // Aruppukkottai
  208: "விருதுநகர்", // Tiruchuli
  209: "இராமநாதபுரம்", // Paramakudi
  210: "இராமநாதபுரம்", // Tiruvadanai
  211: "இராமநாதபுரம்", // Ramanathapuram
  212: "இராமநாதபுரம்", // Mudukulathur
  213: "தூத்துக்குடி", // Vilathikulam
  214: "தூத்துக்குடி", // Thoothukudi
  215: "தூத்துக்குடி", // Tiruchendur
  216: "தூத்துக்குடி", // Srivaikuntam
  217: "தூத்துக்குடி", // Ottapidaram
  218: "தூத்துக்குடி", // Kovilpatti
  219: "தென்காசி", // Sankarankovil
  220: "தென்காசி", // Vasudevanallur
  221: "தென்காசி", // Kadayanallur
  222: "தென்காசி", // Tenkasi
  223: "தென்காசி", // Alangulam
  224: "திருநெல்வேலி", // Tirunelveli
  225: "திருநெல்வேலி", // Ambasamudram
  226: "திருநெல்வேலி", // Palayamkottai
  227: "திருநெல்வேலி", // Nanguneri
  228: "திருநெல்வேலி", // Radhapuram
  229: "கன்னியாகுமரி", // Kanniyakumari
  230: "கன்னியாகுமரி", // Nagercoil
  231: "கன்னியாகுமரி", // Colachel
  232: "கன்னியாகுமரி", // Padmanabhapuram
  233: "கன்னியாகுமரி", // Vilavancode
  234: "கன்னியாகுமரி" // Killiyoor
};

export const districtColors = {
  திருவள்ளூர்: "#6C5CE7",
  சென்னை: "#FD79A8",
  செங்கல்பட்டு: "#00CEC9",
  காஞ்சிபுரம்: "#0984E3",
  இராணிப்பேட்டை: "#E17055",
  வேலூர்: "#00B894",
  திருப்பத்தூர்: "#FDCB6E",
  கிருஷ்ணகிரி: "#E84393",
  தருமபுரி: "#A29BFE",
  திருவண்ணாமலை: "#55EFC4",
  விழுப்புரம்: "#74B9FF",
  கள்ளக்குறிச்சி: "#FF7675",
  சேலம்: "#FFEAA7",
  நாமக்கல்: "#81ECEC",
  ஈரோடு: "#DFE6E9",
  திருப்பூர்: "#B2BEC3",
  நீலகிரி: "#2ECC71",
  கோயம்புத்தூர்: "#3498DB",
  திண்டுக்கல்: "#E74C8B",
  கரூர்: "#F39C12",
  திருச்சிராப்பள்ளி: "#1ABC9C",
  பெரம்பலூர்: "#9B59B6",
  அரியலூர்: "#E67E22",
  கடலூர்: "#5DADE2",
  மயிலாடுதுறை: "#48C9B0",
  நாகப்பட்டினம்: "#AF7AC5",
  திருவாரூர்: "#F1948A",
  தஞ்சாவூர்: "#85C1E9",
  புதுக்கோட்டை: "#76D7C4",
  சிவகங்கை: "#F0B27A",
  மதுரை: "#D35400",
  தேனி: "#AED6F1",
  விருதுநகர்: "#A3E4D7",
  இராமநாதபுரம்: "#D7BDE2",
  தூத்துக்குடி: "#F5B041",
  தென்காசி: "#82E0AA",
  திருநெல்வேலி: "#F1C40F",
  கன்னியாகுமரி: "#EC7063"
};

export const constituencyNames = {
  1: "கும்மிடிப்பூண்டி",
  2: "பொன்னேரி - தனி",
  3: "திருத்தணி",
  4: "திருவள்ளூர்",
  5: "பூவிருந்தவல்லி - தனி",
  6: "ஆவடி",
  7: "மதுரவாயல்",
  8: "அம்பத்தூர்",
  9: "மாதவரம்",
  10: "திருவெற்றியூர்",
  11: "மருத்துவர்.ராதாகிருஷ்ணன் நகர்",
  12: "பெரம்பூர்",
  13: "கொளத்தூர்",
  14: "வில்லிவாக்கம்",
  15: "திரு.வி.க.நகர் - தனி",
  16: "எழும்பூர் - தனி",
  17: "ராயபுரம்",
  18: "துறைமுகம்",
  19: "சேப்பாக்கம் – திருவல்லிகேனி",
  20: "ஆயிரம் விளக்கு",
  21: "அண்ணாநகர்",
  22: "விருகம்பாக்கம்",
  23: "சைதாப்பேட்டை",
  24: "தியாகராயநகர்",
  25: "மயிலாப்பூர்",
  26: "வேளச்சேரி",
  27: "சோழிங்கநல்லூர்",
  28: "ஆலந்தூர்",
  29: "ஸ்ரீபெரும்புதூர் - தனி",
  30: "பல்லாவரம்",
  31: "தாம்பரம்",
  32: "செங்கல்பட்டு",
  33: "திருப்போரூர்",
  34: "செய்யூர் - தனி",
  35: "மதுராந்தகம் - தனி",
  36: "உத்திரமேரூர்",
  37: "காஞ்சிபுரம்",
  38: "அரக்கோணம் - தனி",
  39: "சோளிங்கர்",
  40: "காட்பாடி",
  41: "இராணிப்பேட்டை",
  42: "ஆற்காடு",
  43: "வேலூர்",
  44: "அணைக்கட்டு",
  45: "கீழ்வைத்தியனான்குப்பம் - தனி",
  46: "குடியாத்தம் - தனி",
  47: "வாணியம்பாடி",
  48: "ஆம்பூர்",
  49: "ஜோலார்பேட்டை",
  50: "திருப்பத்தூர்",
  51: "ஊத்தங்கரை - தனி",
  52: "பர்கூர்",
  53: "கிருஷ்ணகிரி",
  54: "வேப்பனஹள்ளி",
  55: "ஓசூர்",
  56: "தளி",
  57: "பாலக்கோடு",
  58: "பென்னாகரம்",
  59: "தர்மபுரி",
  60: "பாப்பிரெட்டிபட்டி",
  61: "அரூர் - தனி",
  62: "செங்கம் - தனி",
  63: "திருவண்ணாமலை",
  64: "கீழ்பென்னாத்தூர்",
  65: "கலசபாக்கம்",
  66: "போளூர்",
  67: "ஆரணி",
  68: "செய்யார்",
  69: "வந்தவாசி - தனி",
  70: "செஞ்சி",
  71: "மயிலம்",
  72: "திண்டிவனம் - தனி",
  73: "வானூர் - தனி",
  74: "விழுப்புரம்",
  75: "விக்கிரவாண்டி",
  76: "திருக்கோயிலூர்",
  77: "உளுந்தூர்பேட்டை",
  78: "ரிஷிவந்தியம்",
  79: "சங்கராபுரம்",
  80: "கள்ளக்குறிச்சி - தனி",
  81: "கெங்கவல்லி - தனி",
  82: "ஆத்தூர் - தனி",
  83: "ஏற்காடு - தனி/ST",
  84: "ஓமலூர்",
  85: "மேட்டூர்",
  86: "எடப்பாடி",
  87: "சங்ககிரி",
  88: "சேலம்-மேற்கு",
  89: "சேலம்-வடக்கு",
  90: "சேலம்-தெற்கு",
  91: "வீரபாண்டி",
  92: "இராசிபுரம் - தனி",
  93: "சேந்தமங்கலம் - தனி/ST",
  94: "நாமக்கல்",
  95: "பரமத்தி வேலூர்",
  96: "திருச்செங்கோடு",
  97: "குமாரபாளையம்",
  98: "ஈரோடு - கிழக்கு",
  99: "ஈரோடு - மேற்கு",
  100: "மொடக்குறிச்சி",
  101: "தாராபுரம் - தனி",
  102: "காங்கேயம்",
  103: "பெருந்துறை",
  104: "பவானி",
  105: "அந்தியூர்",
  106: "கோபிசெட்டிபாளையம்",
  107: "பவானிசாகர் - தனி",
  108: "உதகமண்டலம்",
  109: "கூடலூர் - தனி",
  110: "குன்னூர்",
  111: "மேட்டுப்பாளையம்",
  112: "அவினாசி - தனி",
  113: "திருப்பூர் வடக்கு",
  114: "திருப்பூர் தெற்கு",
  115: "பல்லடம்",
  116: "சூலூர்",
  117: "கவுண்டம்பாளையம்",
  118: "கோயம்புத்தூர் வடக்கு",
  119: "தொண்டாமுத்தூர்",
  120: "கோயம்புத்தூர் தெற்கு",
  121: "சிங்காநல்லூர்",
  122: "கிணத்துக்கடவு",
  123: "பொள்ளாச்சி",
  124: "வால்பாறை - தனி",
  125: "உடுமலைப்பேட்டை",
  126: "மடத்துக்குளம்",
  127: "பழனி",
  128: "ஒட்டன்சத்திரம்",
  129: "ஆத்தூர்",
  130: "நிலக்கோட்டை - தனி",
  131: "நத்தம்",
  132: "திண்டுக்கல்",
  133: "வேடசந்தூர்",
  134: "அரவக்குறிச்சி",
  135: "கரூர்",
  136: "கிருஷ்ணராயபுரம் - தனி",
  137: "குளித்தலை",
  138: "மணப்பாறை",
  139: "திருவரங்கம்",
  140: "திருச்சிராப்பள்ளி மேற்கு",
  141: "திருச்சிராப்பள்ளி கிழக்கு",
  142: "திருவெறும்பூர்",
  143: "இலால்குடி",
  144: "மண்ணச்சநல்லூர்",
  145: "முசிறி",
  146: "துறையூர் - தனி",
  147: "பெரம்பலூர் - தனி",
  148: "குன்னம்",
  149: "அரியலூர்",
  150: "ஜெயங்கொண்டம்",
  151: "திட்டக்குடி - தனி",
  152: "விருத்தாசலம்",
  153: "நெய்வேலி",
  154: "பண்ருட்டி",
  155: "கடலூர்",
  156: "குறிஞ்சிப்பாடி",
  157: "புவனகிரி",
  158: "சிதம்பரம்",
  159: "காட்டுமண்ணார்கோயில் - தனி",
  160: "சீர்காழி - தனி",
  161: "மயிலாடுதுறை",
  162: "பூம்புகார்",
  163: "நாகப்பட்டினம்",
  164: "கீழ்வேளூர் - தனி",
  165: "வேதாரண்யம்",
  166: "திருத்துறைப்பூண்டி - தனி",
  167: "மன்னார்குடி",
  168: "திருவாரூர்",
  169: "நன்னிலம்",
  170: "திருவிடைமருதூர் - தனி",
  171: "கும்பகோணம்",
  172: "பாபநாசம்",
  173: "திருவையாறு",
  174: "தஞ்சாவூர்",
  175: "ஒரத்தநாடு",
  176: "பட்டுக்கோட்டை",
  177: "பேராவூரணி",
  178: "கந்தர்வக்கோட்டை - தனி",
  179: "விராலிமலை",
  180: "புதுக்கோட்டை",
  181: "திருமயம்",
  182: "ஆலங்குடி",
  183: "அறந்தாங்கி",
  184: "காரைக்குடி",
  185: "திருப்பத்தூர்",
  186: "சிவகங்கை",
  187: "மானாமதுரை - தனி",
  188: "மேலூர்",
  189: "மதுரை கிழக்கு",
  190: "சோழவந்தான் - தனி",
  191: "மதுரை வடக்கு",
  192: "மதுரை தெற்கு",
  193: "மதுரை மத்தியம்",
  194: "மதுரை மேற்கு",
  195: "திருப்பரங்குன்றம்",
  196: "திருமங்கலம்",
  197: "உசிலம்பட்டி",
  198: "ஆண்டிப்பட்டி",
  199: "பெரியகுளம் - தனி",
  200: "போடிநாயக்கனூர்",
  201: "கம்பம்",
  202: "இராஜபாளையம்",
  203: "திருவில்லிபுத்தூர் - தனி",
  204: "சாத்தூர்",
  205: "சிவகாசி",
  206: "விருதுநகர்",
  207: "அருப்புக்கோட்டை",
  208: "திருச்சுழி",
  209: "பரமக்குடி - தனி",
  210: "திருவாடானை",
  211: "இராமநாதபுரம்",
  212: "முதுகுளத்தூர்",
  213: "விளாத்திகுளம்",
  214: "தூத்துக்குடி",
  215: "திருச்செந்தூர்",
  216: "ஸ்ரீவைகுண்டம்",
  217: "ஓட்டப்பிடாரம் - தனி",
  218: "கோவில்பட்டி",
  219: "சங்கரன்கோவில் - தனி",
  220: "வாசுதேவநல்லூர் - தனி",
  221: "கடையநல்லூர்",
  222: "தென்காசி",
  223: "ஆலங்குளம்",
  224: "திருநெல்வேலி",
  225: "அம்பாசமுத்திரம்",
  226: "பாளையங்கோட்டை",
  227: "நாங்குநேரி",
  228: "இராதாபுரம்",
  229: "கன்னியாகுமரி",
  230: "நாகர்கோவில்",
  231: "குளச்சல்",
  232: "பத்மனாபபுரம்",
  233: "விளவங்கோடு",
  234: "கிள்ளியூர்"
};

export const constituencyUrls = {
  1: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/gummidipoondi",
  2: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/ponneri-sc",
  3: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/tiruttani",
  4: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/tiruvallur",
  5: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/ponnamallee-sc",
  6: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/avadi",
  7: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/madhuravoyal",
  8: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/ambattur",
  9: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/madhavaram",
  10: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/tiruvottiyur",
  11: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/dr-radhakrishnan-nagar",
  12: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/perambur",
  13: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/kolathur",
  14: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/villivakkam",
  15: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/thiru-vi-ka-nagar",
  16: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/egmore-sc",
  17: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/royapuram",
  18: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/harbour",
  19: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/chepauk-thiruvallikeni",
  20: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/thousand-lights",
  21: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/anna-nagar",
  22: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/virugampakkam",
  23: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/saidapet",
  24: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/thiyagarayanagar",
  25: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/mylapore",
  26: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/velachery",
  27: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/shozhinganallur",
  28: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/alandur",
  29: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/sriperumbudur-sc",
  30: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/pallavaram",
  31: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/tambaram",
  32: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/chengalpattu",
  33: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/thiruporur",
  34: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/cheyyur-sc",
  35: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/maduranthakam-sc",
  36: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/uthiramerur",
  37: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/kanchipuram",
  38: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/arakkonam-sc",
  39: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/sholinghur",
  40: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/katpadi",
  41: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/ranipet",
  42: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/arcot",
  43: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/vellore",
  44: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/anaikattu",
  45: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/kilvaithinankuppam-sc",
  46: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/gudiyattam-sc",
  47: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/vaniyambadi",
  48: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/ambur",
  49: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/jolarpet",
  50: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/tirupathur",
  51: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/uthangarai-sc",
  52: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/bargur",
  53: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/krishnagiri",
  54: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/veppanahalli",
  55: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/hosur",
  56: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/thali",
  57: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/palacodu",
  58: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/pennagaram",
  59: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/dharmapuri",
  60: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/pappireddipatti",
  61: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/harur-sc",
  62: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/chengam",
  63: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/tiruvannamalai",
  64: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/kilpennathur",
  65: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/kalasapakkam",
  66: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/polur",
  67: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/arni",
  68: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/cheyyar",
  69: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/vandavasi",
  70: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/gingee",
  71: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/mailam",
  72: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/tindivanam-sc",
  73: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/vanur-sc",
  74: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/viluppuram",
  75: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/vikkaravandi",
  76: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/tirukkoyilur",
  77: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/ulundurpettai",
  78: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/rishivandiyam",
  79: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/sankarapuram",
  80: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/kallakurichi-sc",
  81: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/gangavalli-sc",
  82: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/attur-sc",
  83: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/yercaud-st",
  84: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/omalur",
  85: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/mettur",
  86: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/edappadi",
  87: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/sankari",
  88: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/salem-west",
  89: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/salem-north",
  90: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/salem-south",
  91: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/veerapandi",
  92: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/rasipuram-sc",
  93: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/senthamangalam-st",
  94: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/namakkal",
  95: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/paramathi-velur",
  96: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/tiruchengode",
  97: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/kumarapalayam",
  98: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/erode-east",
  99: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/erode-west",
  100: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/modakkurichi",
  101: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/dharapuram-sc",
  102: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/kangeyam",
  103: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/perundurai",
  104: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/bhavani",
  105: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/anthiyur",
  106: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/gobichettipalayam",
  107: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/bhavanisagar-sc",
  108: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/udhagamandalam",
  109: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/gudalur-sc",
  110: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/coonoor",
  111: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/mettuppalayam",
  112: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/avanashi-sc",
  113: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/tiruppur-north",
  114: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/tiruppur-south",
  115: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/palladam",
  116: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/sulur",
  117: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/kavundampalayam",
  118: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/coimbatore-north",
  119: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/thondamuthur",
  120: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/coimbatore-south",
  121: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/singanalur",
  122: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/kinathukadavu",
  123: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/pollachi",
  124: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/valparai-sc",
  125: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/udumalaipettai",
  126: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/madathukulam",
  127: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/palani",
  128: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/oddenchatram",
  129: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/athoor",
  130: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/nilakkottai",
  131: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/natham",
  132: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/dindigul",
  133: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/vedasandur",
  134: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/aravakaurichi",
  135: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/karur",
  136: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/krishnarayapuram-sc",
  137: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/kulithalai",
  138: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/manapparai",
  139: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/srirangam",
  140: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/tiruchirappalli-west",
  141: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/tiruchirappalli-east",
  142: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/thiruverumbur",
  143: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/lalgudi",
  144: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/manachanallur",
  145: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/musiri",
  146: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/thuraiyur-sc",
  147: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/perambalur-sc",
  148: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/kunnam",
  149: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/ariyalur",
  150: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/jayankondam",
  151: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/tittakudi-sc",
  152: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/vridhachalam",
  153: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/neyveli",
  154: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/panruti",
  155: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/cuddalore",
  156: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/kurinjipadi",
  157: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/bhuvanagiri",
  158: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/chidambaram",
  159: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/kattumannarkoil-sc",
  160: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/sirkali-sc",
  161: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/mayiladuthurai",
  162: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/poompuhar",
  163: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/nagapattinam",
  164: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/kilvelur-sc",
  165: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/vedaranyam",
  166: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/thiruthuraipoondi-sc",
  167: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/mannargudi",
  168: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/thiruvarur",
  169: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/nannilam",
  170: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/thiruvidaimarudur-sc",
  171: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/kumbakonam",
  172: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/papanasam",
  173: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/thiruvaiyaru",
  174: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/thanjavur",
  175: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/orathanadu",
  176: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/pattukkottai",
  177: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/peravurani",
  178: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/gandharvakottai-sc",
  179: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/viralimalai",
  180: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/pudukkottai",
  181: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/thirumayam",
  182: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/alangudi",
  183: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/aranthangi",
  184: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/karaikudi",
  185: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/tiruppattur",
  186: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/sivagangai",
  187: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/manamadurai-sc",
  188: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/melur",
  189: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/madurai-east",
  190: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/sholavandan-sc",
  191: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/madurai-north",
  192: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/madurai-south",
  193: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/madurai-central",
  194: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/madurai-west",
  195: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/thiruparankundram",
  196: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/thirumangalam",
  197: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/usilampatti",
  198: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/andipatti",
  199: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/periakulam-sc",
  200: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/bodinayakanur",
  201: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/cumbum",
  202: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/rajapalayam",
  203: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/srivilliputhur-sc",
  204: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/sattur",
  205: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/sivakasi",
  206: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/virudhunagar",
  207: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/aruppukottai",
  208: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/tiruchuli",
  209: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/paramakudi-sc",
  210: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/tiruvadanai",
  211: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/ramanathapuram",
  212: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/mudukulathur",
  213: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/vilathikulam",
  214: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/thoothukudi",
  215: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/tiruchendur",
  216: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/srivaikundam",
  217: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/ottapidaram",
  218: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/kovilpatti",
  219: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/sankarankovil",
  220: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/vasudevanallur-sc",
  221: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/kadayanallur",
  222: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/tenkasi",
  223: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/alangulam",
  224: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/tirunelveli",
  225: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/ambasamudram",
  226: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/palayamkottai",
  227: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/nanguneri",
  228: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/radhapuram",
  229: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/kanyakumari",
  230: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/nagercoil",
  231: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/colachel",
  232: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/padmanabhapuram",
  233: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/vilavancode",
  234: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/killiyoor"
};
